import Vue from 'vue'
import axios from 'axios'
import { apiV1 } from '../helpers/shared'

// Objets partagé pour que tous les composants voient les mêmes réglages
const sharedSettings = {
    // Contacts
    support_phone: '(228) 22 20 81 50 / 20 81 51 / 23 49 00',
    support_email: 'info@groupensia.com',
    address_nsia: 'Rue Brazza derrière la grande poste',
    notification_email: 'nsiadirect.togo@groupensia.com',
    
    // Tarifs et Taxes (Valeurs par défaut)
    taxe_rate: 0.06,
    frais_dossier: 2000,
    avenant_annual: 5000,
    avenant_short: 2500,
    prefix_habitation: 'TG2000MRH',
    prefix_voyage: 'TG2000137'
};

Vue.mixin({
    data() {
        return {
            settings: sharedSettings
        }
    },
    created() {
        // Un seul appel global au démarrage
        if (!window._isSettingsFetching) {
            window._isSettingsFetching = true;
            this.fetchPublicSettings();
        }
    },
    methods: {
        fetchPublicSettings() {
            axios
                .get(apiV1("settings/public"))
                .then((response) => {
                    if (response.data.status) {
                        // Mise à jour de l'objet partagé
                        Object.assign(sharedSettings, response.data.settings);
                    }
                })
                .catch((error) => {
                    console.log('Error fetching settings:', error);
                });
        }
    }
})
